import {useEffect, useRef, useState} from "react";
import Axios from "axios";
import {Endpoints} from "../../network/Endpoints";
import {API} from "../../network/API";
import LoadingSpinner from "../common/LoadingSpinner";
import "../common/AlertModal.css";

export const TestNotificationModal = (props) => {

    const {shown, callback} = props;

    const [emailSearch, setEmailSearch] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [testMessage, setTestMessage] = useState("");
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [networkInFlight, setNetworkInFlight] = useState(false);
    const [searchInFlight, setSearchInFlight] = useState(false);
    const [isDismissing, setIsDismissing] = useState(false);

    const searchTimer = useRef(null);

    useEffect(() => {
        if (!shown) {
            setEmailSearch("");
            setSearchResults([]);
            setSelectedUsers([]);
            setTestMessage("");
            setError(null);
            setSuccess(null);
            setIsDismissing(false);
        }
    }, [shown]);

    useEffect(() => {
        if (emailSearch.trim().length < 2) {
            setSearchResults([]);
            return;
        }
        clearTimeout(searchTimer.current);
        searchTimer.current = setTimeout(() => searchUsers(emailSearch), 400);
        return () => clearTimeout(searchTimer.current);
    }, [emailSearch]);

    useEffect(() => {
        let timer;
        if (isDismissing) {
            timer = setTimeout(() => {
                setIsDismissing(false);
                if (callback) callback();
            }, 200);
        }
        return () => clearTimeout(timer);
    }, [isDismissing]);

    function searchUsers(keyword) {
        setSearchInFlight(true);
        const formData = new FormData();
        formData.append("page", 1);
        formData.append("limit", 10);
        formData.append("keyword", keyword);
        formData.append("userRoleId", 2);//exclude CMS users (this was the neil @ certsure issue!)

        Axios.post(Endpoints.user.getUsers, formData)
            .then((r) => {
                const resp = API.parse(r);
                if (resp.success) {
                    setSearchResults(resp.data.data);
                }
                setSearchInFlight(false);
            })
            .catch(() => setSearchInFlight(false));
    }

    function addUser(user) {
        if (selectedUsers.find(u => u.id === user.id)) return;
        setSelectedUsers(prev => [...prev, user]);
    }

    function removeUser(userId) {
        setSelectedUsers(prev => prev.filter(u => u.id !== userId));
    }

    function sendTestNotification() {
        if (networkInFlight) return;

        if (selectedUsers.length === 0) {
            setError("Please add at least one user to the list.");
            return;
        }
        if (!testMessage.trim()) {
            setError("Please enter a test message.");
            return;
        }

        setError(null);
        setNetworkInFlight(true);

        const formData = new FormData();
        selectedUsers.forEach(u => formData.append("userIds[]", u.id));
        formData.append("message", testMessage);

        Axios.post(Endpoints.messaging.sendTestNotification, formData)
            .then((r) => {
                const resp = API.parse(r);
                if (resp.success) {
                    setSuccess(resp.data);
                } else {
                    setError(API.formatError(resp));
                }
                setNetworkInFlight(false);
            })
            .catch(() => {
                setError("An unknown error has occurred. Please try again.");
                setNetworkInFlight(false);
            });
    }

    if (!shown) return null;

    const overlayClass = "alert-modal" + (isDismissing ? " dismissing" : "");

    return (
        <div className={overlayClass}>
            <div className={"spacer"} />
            <div className={"container"}>
                <div className={"row"}>
                    <div className={"col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2"}>
                        <div className={"alert-modal-dialog"} style={{textAlign: "left"}}>

                            <div className={"row"}>
                                <div className={"col-12 text-center"}>
                                    <h3>Send Test Notification</h3>
                                </div>
                            </div>

                            {!success ? (
                                <>
                                    <div className={"row mt-3"}>
                                        <div className={"col-12"}>
                                            <input
                                                type={"text"}
                                                className={"form-control"}
                                                placeholder={"Start typing user's email..."}
                                                value={emailSearch}
                                                onChange={(e) => setEmailSearch(e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    <div className={"row mt-2"}>
                                        <div className={"col-12"}>
                                            <div style={{height: "210px", overflowY: "auto", border: "1px solid #dee2e6", borderRadius: "6px", padding: "4px"}}>
                                                {searchInFlight && (
                                                    <div className={"text-center mt-3"}>
                                                        <LoadingSpinner shown={true} />
                                                    </div>
                                                )}
                                                {!searchInFlight && searchResults.length > 0 && (
                                                    <table className={"table table-sm table-hover mb-0"}>
                                                        <thead>
                                                            <tr>
                                                                <th>First Name</th>
                                                                <th>Last Name</th>
                                                                <th>Email</th>
                                                                <th>Active</th>
                                                                <th></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {searchResults.map(user => {
                                                                const alreadyAdded = !!selectedUsers.find(u => u.id === user.id);
                                                                return (
                                                                    <tr key={user.id}>
                                                                        <td>{user.givenName}</td>
                                                                        <td>{user.familyName}</td>
                                                                        <td>{user.emailAddress}</td>
                                                                        <td>{parseInt(user.active) === 1 ? "Yes" : "No"}</td>
                                                                        <td>
                                                                            <button
                                                                                className={"btn btn-sm btn-light"}
                                                                                onClick={() => addUser(user)}
                                                                                disabled={alreadyAdded}>
                                                                                {alreadyAdded ? "Added" : "Add to List"}
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                )}
                                                {!searchInFlight && searchResults.length === 0 && (
                                                    <div className={"text-center text-muted mt-3"} style={{fontSize: "0.9em"}}>
                                                        {emailSearch.trim().length < 2 ? "Start typing to search for users" : "No users found"}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className={"row mt-3"}>
                                        <div className={"col-12"}>
                                            <label><strong>Selected Users</strong></label>
                                            <div style={{maxHeight: "150px", overflowY: "auto", border: "1px solid #dee2e6", borderRadius: "6px", padding: "4px", minHeight: "42px"}}>
                                                {selectedUsers.length === 0 ? (
                                                    <div className={"text-center text-muted mt-1"} style={{fontSize: "0.9em"}}>No users added yet</div>
                                                ) : (
                                                    <table className={"table table-sm mb-0"}>
                                                        <tbody>
                                                            {selectedUsers.map(user => (
                                                                <tr key={user.id}>
                                                                    <td>{user.givenName} {user.familyName}</td>
                                                                    <td>{user.emailAddress}</td>
                                                                    <td className={"text-end"}>
                                                                        <button
                                                                            className={"btn btn-sm btn-outline-danger"}
                                                                            onClick={() => removeUser(user.id)}>
                                                                            Remove
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className={"row mt-3"}>
                                        <div className={"col-12"}>
                                            <label>Test Message</label>
                                            <textarea
                                                className={"form-control"}
                                                rows={3}
                                                placeholder={"Enter test message..."}
                                                value={testMessage}
                                                onChange={(e) => setTestMessage(e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    {error && (
                                        <div className={"row mt-2"}>
                                            <div className={"col-12"}>
                                                <span className={"text-danger"}>{error}</span>
                                            </div>
                                        </div>
                                    )}

                                    <div className={"row mt-3"}>
                                        <div className={"col-12 text-center"}>
                                            {networkInFlight ? (
                                                <LoadingSpinner shown={true} />
                                            ) : (
                                                <>
                                                    <button className={"btn btn-success"} onClick={sendTestNotification}>
                                                        Send Message
                                                    </button>
                                                    <button className={"btn btn-secondary ms-2"} onClick={() => setIsDismissing(true)}>
                                                        Cancel
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <div className={"row mt-3"}>
                                    <div className={"col-12"}>
                                        <p className={"text-success fs-5 text-center"}>
                                            <strong>Attempted send to {success.androidTokens} Android token{success.androidTokens !== 1 ? "s" : ""} and {success.iosTokens} iOS token{success.iosTokens !== 1 ? "s" : ""}.</strong>
                                        </p>
                                        {success.results && success.results.length > 0 && (
                                            <div style={{maxHeight: "300px", overflowY: "auto", border: "1px solid #dee2e6", borderRadius: "6px"}}>
                                                <table className={"table table-sm mb-0"}>
                                                    <thead className={"table-light"} style={{position: "sticky", top: 0}}>
                                                        <tr>
                                                            <th>Email</th>
                                                            <th>Platform</th>
                                                            <th>Token ending</th>
                                                            <th>Result</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {success.results.map((r, i) => (
                                                            <tr key={i}>
                                                                <td>{r.email}</td>
                                                                <td>{r.platform === "ios" ? "iOS" : r.platform === "android" ? "Android" : "-"}</td>
                                                                <td>{r.tokenSuffix}</td>
                                                                <td>
                                                                    <span className={r.status === "success" ? "text-success" : r.status === "no tokens found" ? "text-muted" : "text-danger"}>
                                                                        {r.status}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                        {success.results && success.results.length === 0 && (
                                            <p className={"text-muted text-center"}>No push tokens found for the selected users.</p>
                                        )}
                                        <div className={"text-center mt-3"}>
                                            <button className={"btn btn-light"} onClick={() => setIsDismissing(true)}>
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </div>
            <div className={"spacer"} />
        </div>
    );
};
